"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRangeVariablesDependencyProposal = exports.createMiscConstantFormulaDependencyProposals = exports.createFormulaDependencyProposals = void 0;
const formula_engine_1 = require("@finley-technologies/formula-engine");
/**
 * Generates Monaco Editor Snippet text for function definitions
 * @param documentation
 * @returns string
 */
const generateSnippetInsertText = (documentation, prettyPrint) => {
    const newString = documentation.slice(0, -1);
    const [formulaName, variablesString] = newString.split('(');
    const variables = variablesString.split(',');
    const snippetVariables = variables.map((variable, index) => `${prettyPrint ? '\n\t' : ''}\${${String(index + 1)}:${variable.trim()}}`);
    return `${formulaName}(${snippetVariables.join()}${prettyPrint ? '\n)' : ')'}`;
};
/**
 * Generates list of valid function CompletionItems for Monaco Editor
 */
const createFormulaDependencyProposals = (input) => {
    // TODO: clarify function naming as we better clarify our usages of existing
    // formula engines (currently HyperEngine and ExcelEngine)
    // This should be done in alignment with the formula engine support migration
    // Keep in mind that we still may want to support not enabling full function availability
    const targetFunctions = (input === null || input === void 0 ? void 0 : input.useFullFunctions)
        ? formula_engine_1.fullValidFunctions
        : formula_engine_1.validFunctions;
    return Array.from(targetFunctions).map((validFunction) => {
        const [label, { functionDefinition, description }] = validFunction;
        return {
            label,
            documentation: `${functionDefinition}\n ${description}`,
            insertText: generateSnippetInsertText(functionDefinition, (input === null || input === void 0 ? void 0 : input.prettyPrint) || false),
        };
    });
};
exports.createFormulaDependencyProposals = createFormulaDependencyProposals;
/**
 * Generates list of helpful constant CompletionItems for Monaco Editor
 */
const createMiscConstantFormulaDependencyProposals = () => [
    { label: 'TRUE', description: 'TRUE' },
    { label: 'FALSE', description: 'FALSE' },
].map(({ label, description }) => {
    return {
        label,
        documentation: description,
        insertText: label,
    };
});
exports.createMiscConstantFormulaDependencyProposals = createMiscConstantFormulaDependencyProposals;
const createRangeVariablesDependencyProposal = (inputDependencies) => {
    const output = [];
    for (const { label, documentation, insertText } of inputDependencies) {
        output.push({
            label: (0, formula_engine_1.createRangeVariable)(label),
            documentation,
            insertText: (0, formula_engine_1.createRangeVariable)(insertText),
        });
    }
    return output;
};
exports.createRangeVariablesDependencyProposal = createRangeVariablesDependencyProposal;
//# sourceMappingURL=validFunctions.js.map